'use client'
import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'
import useAuthentication from 'app/hooks/useAuthentication'
import { Loading } from 'app/components/atoms'

const SignIn: React.FC = () => {
  const { login, isLoading, data: sessionData } = useAuthentication()
  const searchParams = useSearchParams()
  const callbackUrl = searchParams?.get('callbackUrl') || undefined

  useEffect(() => {
    if (!isLoading) {
      login({
        callbackUrl,
        prompt: sessionData?.isTriplaSignInError ? 'login' : undefined,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, sessionData?.isTriplaSignInError])

  return (
    <div className="mt-[50vh]">
      <Loading className="!text-gray-bg" baseClassName="!text-primary" />
    </div>
  )
}

export default SignIn
